import { observer } from 'mobx-react-lite'
import { useAIAgentLocation } from 'app/components/ai-agent-location/useAIAgentLocation'
import { AIAgentLocationComponent } from 'app/components/ai-agent-location/AIAgentLocationComponent'

const AIAgentLocationView = observer(function AIAgentLocationView() {
  const props = useAIAgentLocation()
  return <AIAgentLocationComponent {...props} />
})

export default AIAgentLocationView
